import Vue from "vue";
import { downloadFileData } from "@/api/publicApi";
import { baseURL, tokenName } from "@/config/net.config";

/**
 *@desc 导出
 *@author wsx
 *@date 2022-11-07 16:38:11
 */
export function downloadData(
  downloadUrl,
  downloadData = null,
  downloadMethod = "post",
  text,
  type = "xlsx"
) {
  //全屏loading遮罩
  const loading = Vue.prototype.$loading({
    lock: true,
    text: "请求中~",
    spinner: "el-icon-loading",
    background: "rgba(255, 255, 255, 0.8)"
  });
  downloadFileData(
    downloadData,
    downloadUrl,
    downloadMethod.toLowerCase()
  ).then((res) => {
    const fileName = `${text}.${type}`;
    const fileReader = new FileReader();
    fileReader.onloadend = () => {
      if (res.type === "application/json") {
        const jsonRes = JSON.parse(fileReader.result);
        if (jsonRes.code === 0 || jsonRes.code === -1) {
          Vue.prototype.$notify.error({
            title: "错误",
            message: jsonRes.message || "导出异常！"
          });
          loading.close();
          return false;
        } else {
          Vue.prototype.$notify.error({
            title: "错误",
            message: jsonRes.message || "导出异常！"
          });
          loading.close();
        }
      } else {
        // 将二进制流转为blob
        const blob = new Blob([res]);
        if (typeof window.navigator.msSaveBlob !== "undefined") {
          // 兼容IE，window.navigator.msSaveBlob：以本地方式保存文件
          window.navigator.msSaveBlob(blob, decodeURI(fileName));
          loading.close();
        } else {
          // 创建新的URL并指向File对象或者Blob对象的地址
          const blobURL = window.URL.createObjectURL(blob);
          // 创建a标签，用于跳转至下载链接
          const tempLink = document.createElement("a");
          tempLink.style.display = "none";
          tempLink.href = blobURL;
          tempLink.setAttribute("download", decodeURI(fileName));
          // 兼容：某些浏览器不支持HTML5的download属性
          if (typeof tempLink.download === "undefined") {
            tempLink.setAttribute("target", "_blank");
          }
          // 挂载a标签
          document.body.appendChild(tempLink);
          tempLink.click();
          document.body.removeChild(tempLink);
          // 释放blob URL地址
          window.URL.revokeObjectURL(blobURL);

          loading.close();
        }
      }
    };
    fileReader.readAsText(res);
  });
}

/** 导出
 *@desc
 *@author wsx
 *@date 2022-11-09 14:20:48
 */
export function downloadFormData(url, params = {}) {
  params.token = localStorage.getItem(tokenName);
  // 创建form
  let form = document.createElement("form");
  form.id = "form";
  form.name = "form";
  document.body.appendChild(form);
  // 循环创建input框
  for (let obj in params) {
    let input = document.createElement("input");
    input.type = "hidden";
    input.name = obj;
    input.value = params[obj];
    form.appendChild(input);
  }
  form.method = "post";
  form.action = window.location.origin + baseURL + url;
  form.style.display = "none";
  form.submit();
  document.body.removeChild(form);
}

/**
 *@desc 将对象转换为查询字符串
 *@author wsx
 *@date 2022-11-07 16:44:01
 */
export function queryString(data) {
  const qs = [];
  for (const key in data) {
    if (Object.prototype.hasOwnProperty.call(data, key)) {
      const value = data[key];
      if (Array.isArray(value)) {
        value.forEach((item) => qs.push(`${key}=${encodeURIComponent(item)}`));
      } else if (value === 0 || value) {
        qs.push(`${key}=${encodeURIComponent(value)}`);
      }
    }
  }
  if (qs.length > 0) {
    return `?${qs.join("&")}`;
  }
  return "";
}

/**
 *@desc getUUID
 *@author wsx
 *@date 2022-11-11 14:17:16
 */
export function getUUID() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx"
    .replace(/[xy]/g, (c) => {
      return (c === "x" ? (Math.random() * 16) | 0 : "r&0x3" | "0x8").toString(
        16
      );
    })
    .replace(/[-]/g, "");
}

/**
 *@desc getUUID
 *@author zcl
 *@date 2022年11月15日09:29:13
 */
export function objArrayMerge(array) {
  let dataInfo = {};
  array.forEach((item) => {
    let { year, defFlag } = item;
    if (!dataInfo[year]) {
      dataInfo[year] = {
        year,
        defFlag,
        children: []
      };
    }
    dataInfo[year].children.push(item);
  });
  return Object.values(dataInfo);
}

export function viewImg(imgId) {
  let url = "";
  if (imgId) {
    url = `${baseURL}/dms/file/stream?type=0&id=${imgId}&token=${localStorage.getItem(
      tokenName
    )}&time=${new Date().getTime()}`;
  }
  return url;
}

/**
 *@desc getUUID
 *@author zcl
 *@date 2022年11月15日09:29:13
 */
export function arrayToTree(dataArr, param) {
  param = param || {};
  const before_idkey = param.id || "id";
  const before_parentkey = param.parentId || "parentId";
  const after_childkey = param.children || "child";
  return dataArr.filter((father) => {
    let branchArr = dataArr.filter((child) => {
      return father[before_idkey] === child[before_parentkey];
    });
    if (branchArr.length > 0) {
      father[after_childkey] = branchArr;
      father.hasChildren = true;
      father.showChildren = false;
    } else {
      father.hasChildren = false;
    }
    return !dataArr.some(function (item) {
      return item[before_idkey] === father[before_parentkey];
    });
  });
}

/**
 * 偏移时间
 * @param date 日期
 * @param day 天数
 * @param hour 小时数
 * @param minute 分钟数
 * @param second 秒数
 * @returns {Date} 偏移后的日期
 */
export function dateOffset(date, day = 0, hour = 0, minute = 0, second = 0) {
  const dayVal = day * 24 * 60 * 60 * 1000;
  const timestamp =
    dayVal + hour * 60 * 60 * 1000 + minute * 60 * 1000 + second * 1000;
  return new Date(date.getTime() + timestamp);
}

/**
 * 对象数组去重
 * @param arr 待处理数组
 * @param id 主键
 * @returns {Array } 去重后数组
 */
export function unique(arr, id = "id") {
  const res = new Map();
  return arr.filter((arr) => !res.has(arr[id]) && res.set(arr[id], 1));
}

export function isNull(exp) {
  return (exp === undefined || exp === null) && exp !== 0;
}

// 计算偏移天数
export function DateDiff(start, end) {
  start = new Date(start);
  end = new Date(end);
  let days;
  if (start < end) {
    days = parseInt(Math.abs(end - start) / 1000 / 60 / 60 / 24);
  } else {
    days = 0;
  }
  return days;
}

/**
 * @param { Object } obj
 * @param { String } prop
 */
export function objHasProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

export function phoneFilter(value, num = 4) {
  if (!value) return "";
  return (
    value.substring(0, num - 1) + "****" + value.substr(value.length - num)
  );
}

export function IDCardFilter(value) {
  if (!value) return "";
  return value.replace(/(.{4}).*(.{4})/, "$1**********$2");
}


export function downloadFile(item) {
  const link = document.createElement("a");

  const formData = new FormData();
  formData.append('type', '4');
  formData.append('key', '4');
  formData.append('parent', '0');
  formData.append('name', item.name);
  formData.append('list', [item.id]);
  // 发送POST请求
  fetch('/api/dms/file/download', {
    method: 'POST',
    headers: {
      'token': localStorage.getItem(tokenName)
    },
    body: formData
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.blob();

    })
    .then(blob => {
      // 创建 Blob 对象
      const blobUrl = window.URL.createObjectURL(new Blob([blob]));
      link.href = blobUrl;
      link.download = item.name; // 设置 download 属性以提示浏览器下载文件
      link.style.display = "none"; // 隐藏链接
      // 将链接添加到 DOM 中
      document.body.appendChild(link);
      // 触发点击事件
      link.click();
      // 清理资源
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    })
    .catch(error => {
      console.error('Error:', error);
    });
}